import React, { useCallback, useContext } from 'react';
import { isPlaceOccupied, SeatingViewerContext } from '@wix/seating-common-components';
import classNames from 'classnames';
import s from './whole-table-reservation-wrapper.scss';
export const WholeTableReservationWrapper = ({ children, definition }) => {
    var _a;
    const { selectedPlaceIds, currentlyClickedPlaceId, placesStock, mobile, onPlaceClick, onPlaceMouseEnter, onPlaceMouseLeave, } = useContext(SeatingViewerContext);
    const { seats, categoryId } = definition;
    const handlePlaceClick = useCallback(() => {
        onPlaceClick === null || onPlaceClick === void 0 ? void 0 : onPlaceClick({ place: seats[0], categoryId, definition });
    }, [seats, categoryId, definition, onPlaceClick]);
    const onPlaceEnter = useCallback(event => onPlaceMouseEnter && onPlaceMouseEnter({ event, categoryId, place: seats[0] }), [seats, categoryId, onPlaceMouseEnter]);
    const onPlaceLeave = useCallback(event => onPlaceMouseLeave && onPlaceMouseLeave({ event, categoryId, place: seats[0] }), [seats, categoryId, onPlaceMouseEnter]);
    if (!((_a = definition.reservationOptions) === null || _a === void 0 ? void 0 : _a.reserveWholeElement)) {
        return React.createElement(React.Fragment, null, children);
    }
    const selected = seats.some(seat => selectedPlaceIds.includes(seat.id));
    const clicked = seats.some(seat => seat.id === currentlyClickedPlaceId);
    const occupied = seats.some(seat => isPlaceOccupied(seat, placesStock));
    const selectedOrClicked = selected || clicked;
    const shouldDisableMouseEvents = !selectedOrClicked && occupied;
    return (React.createElement("g", { onClick: shouldDisableMouseEvents ? undefined : handlePlaceClick, onMouseEnter: shouldDisableMouseEvents ? undefined : onPlaceEnter, onMouseLeave: shouldDisableMouseEvents ? undefined : onPlaceLeave, className: classNames(s.wholeTableReservationWrapper, {
            [s.selected]: selectedOrClicked,
            [s.occupied]: occupied,
            [s.mobile]: mobile,
        }) }, children));
};
//# sourceMappingURL=whole-table-reservation-wrapper.js.map